// extracted by mini-css-extract-plugin
export default {"descriptionWrapper":"Description_descriptionWrapper__HvigZ","subDescription":"Description_subDescription__MWh4K","listItem":"Description_listItem__nz-JE"};